import axios from "axios";
import { decodeJwtPayload } from "../utils/jwt";
import { reportSlowNetwork, SLOW_REQUEST_THRESHOLD_MS } from "../utils/networkMonitor";

const getBaseURL = () => {
  // Target the backend on port 5000 using the same hostname we used to open the page
  if (window.location.port === "3000") {
    return `http://${window.location.hostname}:5000/api`;
  }
  // In production, use relative path (handled by Nginx proxy)
  return "/api";
};

export const API = axios.create({
  baseURL: getBaseURL(),
});

// Large file uploads (course videos) go through a dedicated DNS-only subdomain
// instead of the main domain, because Cloudflare's proxy caps request bodies at
// 100MB regardless of what Nginx/the backend allow (verified: 413 from
// Cloudflare on a >100MB video upload). Local dev has no Cloudflare in front,
// so it keeps hitting the backend the same way getBaseURL() does.
export const getUploadBaseURL = () => {
  if (window.location.port === "3000") {
    return `http://${window.location.hostname}:5000/api`;
  }
  return "https://upload.neslife.in/api";
};

// attach token automatically
// Interceptor हर request में automatically token attach करता है
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  config.headers = config.headers || {};

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Timestamped here (not read from response) so the elapsed time below reflects
  // the full request, including whatever network delay happened before a
  // response — or before it failed/timed out — ever came back.
  (config as any)._startTime = Date.now();

  return config;
});

// Response interceptor for handling 401 Unauthorized globally, and flagging a
// slow connection to the rest of the app when a request is unusually slow (or
// fails outright with no response, which is what a dead/very poor connection
// looks like from the browser's side).
API.interceptors.response.use(
  (response) => {
    const startTime = (response.config as any)._startTime;
    if (startTime && Date.now() - startTime > SLOW_REQUEST_THRESHOLD_MS) {
      reportSlowNetwork();
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const token = localStorage.getItem("token");
      const role = token ? decodeJwtPayload(token)?.role : null;
      localStorage.removeItem("token");
      localStorage.removeItem("userName");
      window.location.href = role === "admin" ? "/admin/login" : "/";
    } else if (!error.response) {
      // No response at all (timeout, DNS failure, connection dropped) — a
      // stronger signal than a merely-slow response, so report it immediately.
      reportSlowNetwork();
    }
    return Promise.reject(error);
  }
);